import { ReactElement } from "react";

interface mailModalProps{
    more_flag: boolean;
}


/**
 * 参加登録完了モーダルのコンポーネント
 */
export function MailSendedModal(props:mailModalProps){

    return(
        <>
            <div className="overlay-box">
                <div className="modal-box">
                    <div className="modal-base">
                        <div className="mdl-wrap">
                            <div className="mdl-cont">
                                <dl className="mdl-dl">
                                    <dt>登録が完了しました</dt>
                                    <dt>ご登録のメールアドレスへ確認メールを送信いたしました。</dt>
                                    <dt>登録内容に誤りがないかご確認ください。</dt>
                                    
                                    <div className="btn-area">
                                        <div className="flex-center is-col">
                                            <a href="/mypage" className="btn-main btnsz-l">マイページへ</a>
                                        </div>
                                    </div>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <div className="overlay-bg" />
        </>
    )
}